import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, Grid } from "@mui/material";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

import { DetailsText } from "@/atoms";
import { PageHead } from "@/components";

const TrackDetailsRoyalty = ({ data }) => {
    const { t } = useTranslation();

    const { master, mechanical_performance: mechanicalPerformance, neighboring, synchronization } = data || {};

    return (
        <Box
            sx={{
                alignItems: "start",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <PageHead title={t("labels.royalty")} titleTag="h2" />
            <Grid spacing={2} container>
                <Grid
                    size={{
                        md: 6,
                        xs: 12,
                    }}
                >
                    <DetailsText info={master ? <CheckIcon /> : <ClearIcon color="error" />} tag={t("labels.master")} />
                </Grid>
                <Grid
                    size={{
                        md: 6,
                        xs: 12,
                    }}
                >
                    <DetailsText
                        info={mechanicalPerformance ? <CheckIcon /> : <ClearIcon color="error" />}
                        tag={t("labels.mechanicalPerformance")}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 6,
                        xs: 12,
                    }}
                >
                    <DetailsText
                        info={neighboring ? <CheckIcon /> : <ClearIcon color="error" />}
                        tag={t("labels.neighboring")}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 6,
                        xs: 12,
                    }}
                >
                    <DetailsText
                        info={synchronization ? <CheckIcon /> : <ClearIcon color="error" />}
                        tag={t("labels.synchronization")}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default TrackDetailsRoyalty;

TrackDetailsRoyalty.propTypes = { data: PropTypes.object };
